import { render, staticRenderFns } from "./Radiogroup.vue?vue&type=template&id=cc05e4c0"
import script from "./Radiogroup.vue?vue&type=script&setup=true&lang=js"
export * from "./Radiogroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports